var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maproom-page fill-screen"},[_c('game-map',{attrs:{"startActive":true,"preventHide":true},on:{"navclick":_vm.goto}}),_c('curtain',{attrs:{"active":_vm.curtainActive,"heading":_vm.curtainHeading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }